import { render, staticRenderFns } from "./ObservedTableData.vue?vue&type=template&id=0305c574&scoped=true"
import script from "./ObservedTableData.vue?vue&type=script&lang=js"
export * from "./ObservedTableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0305c574",
  null
  
)

export default component.exports